module.exports = __webpack_public_path__ + "static/media/addIcon.6371aeae.svg";